import React from 'react';
import Svg, {Path, Rect} from 'react-native-svg';

/**
 * MicIconDark — fixed dark-mode variant of MicIcon.
 * Uses a #3A4B61 border rect and #A1B4C3 path strokes.
 * No colour props — colours are baked in for dark mode.
 */
export const MicIconDark = () => (
  <Svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <Rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#3A4B61"
    />
    <Path
      d="M18 11.332C17.4696 11.332 16.9609 11.5427 16.5858 11.9178C16.2107 12.2929 16 12.8016 16 13.332V17.9987C16 18.5291 16.2107 19.0378 16.5858 19.4129C16.9609 19.788 17.4696 19.9987 18 19.9987C18.5304 19.9987 19.0391 19.788 19.4142 19.4129C19.7893 19.0378 20 18.5291 20 17.9987V13.332C20 12.8016 19.7893 12.2929 19.4142 11.9178C19.0391 11.5427 18.5304 11.332 18 11.332Z"
      stroke="#A1B4C3"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M22.6668 16.668V18.0013C22.6668 19.239 22.1752 20.426 21.3 21.3011C20.4248 22.1763 19.2378 22.668 18.0002 22.668C16.7625 22.668 15.5755 22.1763 14.7003 21.3011C13.8252 20.426 13.3335 19.239 13.3335 18.0013V16.668"
      stroke="#A1B4C3"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18 22.668V24.668"
      stroke="#A1B4C3"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);